// 为了防止警告信息，直接指向到js不会提示警告信息
import { createI18n } from 'vue-i18n'

// import en_GB from './en-GB/en-GB.js'
// import zh_CN from './zh-CN/zh-CN.js'
// import ar_AR from './ar-AR/ar-AR.js'
// import de_DE from './de-DE/de-DE.js'
// import fil_PH from './fil-PH/fil-PH.js'
// import es_ES from './es-ES/es-ES.js'
// import fr_FR from './fr-FR/fr-FR.js'
// import id_ID from './id-ID/id-ID.js'
// import it_IT from './it-IT/it-IT.js'
// import pt_PT from './pt-PT/pt-PT.js'
// import ru_RU from './ru-RU/ru-RU.js'
// import th_TH from './th-TH/th-TH.js'
// import vi_VN from './vi-VN/vi-VN.js'
// import zh_TW from './zh-TW/zh-TW.js'
// import km_KH from './km-KH/km-KH.js'
// import my_MM from './my-MM/my-MM.js'

// const messages = {
//   'en-GB':  {
//     ...en_GB
//   },
//   'zh-CN': {
//     ...zh_CN
//   },
//   'ar-AR': {
//     ...ar_AR
//   },
//   'de-DE': {
//     ...de_DE
//   },
//   'fil-PH': {
//     ...fil_PH
//   },
//   'es-ES': {
//     ...es_ES
//   },
//   'fr-FR': {
//     ...fr_FR
//   },
//   'id-ID': {
//     ...id_ID
//   },
//   'it-IT': {
//     ...it_IT
//   },
//   'pt-PT': {
//     ...pt_PT
//   },
//   'ru-RU': {
//     ...ru_RU
//   },
//   'th-TH': {
//     ...th_TH
//   },
//   'vi-VN': {
//     ...vi_VN
//   },
//   'zh-TW': {
//     ...zh_TW
//   },
//   'km-KH': {
//     ...km_KH
//   },
//   'my-MM': {
//     ...my_MM
//   },
// }

const message = {}

const isCN = import.meta.env.VITE_COUNTRY === 'CHINA'
let locale = localStorage.getItem('communityLanguage') ? JSON.parse(localStorage.getItem('communityLanguage')).value : isCN ? 'zh-CN' : 'en-GB'
async function loadLocale(locale) {
  try {
    const module = await import(`./${locale}/${locale}.js`);
    message[locale] = module.default || module; // 根据导出方式选择
  } catch (error) {
    console.error(`load ${locale} fail:`, error);
  }
}

loadLocale(locale);

const i18n = createI18n({
  // 定义的语言 
  locale,
  // 引入各种不同的配置，可直接写在这里
  messages: message,
  legacy: false,
  globalInjection: true,
})

export const $t = i18n.global.t;

export default i18n